import { useState } from 'react';
import { Field } from 'formik';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    InputGroup,
    Input,
    InputRightAddon,
} from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../users/walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const ResourceAccountNameField = ({
    errors,
    touched,
    darkMode,
    initialDomain,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { autoAttendant } = walkthroughIds;
    return (
        <FormControl
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)} pt={2}>
                        Account Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>

                <Field
                    validate={(value) =>
                        !value ? 'Name is required' : undefined
                    }
                    name="name">
                    {({ field }) => {
                        return (
                            <Box sx={{ paddingTop: '15px', minWidth: '442px' }}>
                                <InputGroup
                                    sx={{
                                        height: '30px',
                                        borderRadius: '5px',
                                    }}>
                                    <Input
                                        {...field}
                                        placeholder="Enter account name"
                                        backgroundColor={
                                            darkMode ? 'dark.bgDark' : 'white'
                                        }
                                        borderColor={
                                            darkMode
                                                ? 'dark.tcap-borderGray'
                                                : 'inherit'
                                        }
                                        data-walkthroughid={
                                            autoAttendant.ufAccountName
                                        }
                                        overflow="hidden"
                                        sx={{
                                            height: '30px',
                                            padding: '2px 6px',
                                            borderRadius: '5px 0 0 5px',
                                            flex: '1 1 auto',
                                        }}
                                    />
                                    <InputRightAddon
                                        backgroundColor={
                                            darkMode
                                                ? 'dark.bgDark'
                                                : 'gray.100'
                                        }
                                        borderColor={
                                            darkMode
                                                ? 'dark.tcap-borderGray'
                                                : 'inherit'
                                        }
                                        color={
                                            darkMode ? 'gray.400' : 'gray.500'
                                        }
                                        fontSize="14px"
                                        cursor="not-allowed"
                                        sx={{
                                            height: '30px',
                                            borderRadius: '0 5px 5px 0',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                        }}>
                                        @{initialDomain}
                                    </InputRightAddon>
                                </InputGroup>
                            </Box>
                        );
                    }}
                </Field>

                {isHovered && (
                    <FieldToolTip
                        label="Username of the Auto Attendant."
                        ariaLabel="resource-account-displayname-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ResourceAccountNameField;
